import React from 'react'
import styles from './AiSearch.module.css'
import { Card } from '@paypalcorp/pp-react'

const ConversationCard = ({ children }) => (
  <div className={styles.answerContainer}>
    <Card className={styles.aiSummaryContainer}>{children}</Card>
  </div>
)
export default ConversationCard
